/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_Filter_Global_SettingsInputs */



/**
* | output |
* | --- |
* | "Global Settings" |
*
* @param {Audit_Logs_Filter_Global_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_filter_global_settings = /** @type {((inputs?: Audit_Logs_Filter_Global_SettingsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Filter_Global_SettingsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Globale Einstellungen")
	return /** @type {LocalizedString} */ ("Global Settings")
});